import { DateTime, Interval } from "luxon";

export const formatEpochTime = (
  epochTime: number,
  timeZone: string,
  showDate: boolean,
  showDateWithTomorrow: boolean
) => {
  if (!epochTime) {
    return "";
  }
  const dt = DateTime.fromMillis(epochTime).setZone(timeZone);
  const now = DateTime.now().setZone(timeZone);

  let dayLabel;

  if (showDate) {
    dayLabel = dt.toFormat("MMM d");
  } else {
    if (dt.hasSame(now, "day")) {
      dayLabel = "Today";
    } else if (dt.hasSame(now.plus({ days: 1 }), "day")) {
      dayLabel = showDateWithTomorrow
        ? `Tomorrow (${dt.toFormat("MMM d")})`
        : "Tomorrow";
    } else {
      dayLabel = dt.toFormat("MMM d");
    }
  }

  const timeLabel = dt.toFormat("h:mm a");

  return `${dayLabel} at ${timeLabel}`;
};

export const canScheduleOrderToday = (
  todaysHours: any | undefined,
  now: DateTime,
  timezone: string,
  leadTime: number | undefined
) => {
  if (!todaysHours) return false;

  return todaysHours
    .flatMap((hours: { start: any; end: any }) => {
      const startTime = toDateTime(hours.start, timezone);
      const endTime = toDateTime(hours.end, timezone);

      const interval = Interval.fromDateTimes(startTime, endTime);

      if (interval.isBefore(now)) return false;
      if (interval.isAfter(now)) return true;
      if (interval.contains(now))
        return interval.contains(now.plus({ minutes: leadTime }));

      return false;
    })
    .includes(true);
};

const toDateTime = (time: string, timezone?: string) =>
  DateTime.fromObject(
    {
      hour: getHour(time),
      minute: getMinutes(time),
    },
    { zone: timezone }
  );

const getHour = (time: string) => Math.floor(parseInt(time) / 100);
const getMinutes = (time: string) => parseInt(time) % 100;
